import { AdminMessagingService } from "api/services/admin-messaging/AdminMessagingService";
import { LibraryService } from "api/services/library";
import PageBuilderService from "api/services/page-builder";
import { useState, useEffect } from "react";
import miscUtils from "utils/miscUtils";


export function useLibraryContent(groupData: any) {
    // was moved to this place because we were waiting too long for data updates
    const [courses, setCourses] = useState<any[]>([]);

    useEffect(() => {
        if (groupData && groupData.id && miscUtils.isAdmin(groupData.user_membership)) {
            LibraryService.getInstance()
                .getContents(groupData.id, '', 1, '')
                .then((response: any) => {
                    if (response && response.data.data) {
                        setCourses(response.data.data);
                    }
                }).catch((error: any) => console.error(error))
        }
    }, [groupData]);

    if (courses.length > 0) {
        return true
    }
    else {
        return false
    }
}

export function useWorkflow(groupData: any) {
    // was moved to this place because we were waiting too long for data updates
    const [courses, setCourses] = useState<any>(undefined);


    useEffect(() => {
        if (groupData && groupData.id && miscUtils.isAdmin(groupData.user_membership)) {
            AdminMessagingService.getInstance()
                .fetchWorkflowsList(groupData.id)
                .then((response: any) => {
                    if (response && response.data.data) {
                        const isActive = response.data.data.filter((workflow: any) => workflow.status === 'active');
                        setCourses({
                            exists: response.data.data.length > 0,
                            isActive: isActive.length > 0
                        });
                    }
                }).catch((error: any) => console.error(error))
        }
    }, [groupData]);

    return courses
}


export function useLandingPages(groupData: any) {
    // was moved to this place because we were waiting too long for data updates
    const [courses, setCourses] = useState<any>(undefined);

    useEffect(() => {
        if (groupData && groupData.id && miscUtils.isAdmin(groupData.user_membership)) {
            PageBuilderService.getInstance()
                .getCommunityPages(groupData.id, 1)
                .then((response: any) => {
                    if (response && response.data.data) {
                        const isActive = response.data.data.filter((workflow: any) => workflow.published_at !== null);
                        setCourses({
                            exists: response.data.data.length > 0,
                            isActive: isActive.length > 0
                        });
                    }
                }).catch((error: any) => console.error(error))
        }
    }, [groupData]);

    return courses
}
